import { render } from "./billing.vue?vue&type=template&id=e2f0638c&scoped=true&ts=true"
import script from "./billing.vue?vue&type=script&lang=ts"
export * from "./billing.vue?vue&type=script&lang=ts"

import "./billing.vue?vue&type=style&index=0&id=e2f0638c&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f0638c"]])

export default __exports__